import { AxiosError } from "axios";

export function parseValidationError(validationErrors: string[] = []) {
    let message = '';
    let count = 0;
    for (let i = 0; i < validationErrors.length; i++) {
        const errorMessage = validationErrors[i];

        if (count === Object.keys(validationErrors).length - 1) {
            message += ` ${errorMessage}`
        }
        else{
            message += ` ${errorMessage},`
        }

        count++;
        
    }
    return message;
}

export interface ParseErrorConfig{
    errorMessage404?: string
}

export function parseError(e: AxiosError<any>, config?: ParseErrorConfig): string {
    let defaultMessage = e.message || "An unknown error occured";

    if (e.response) {

        if (e.response.status === 404 && config?.errorMessage404) {
            return config.errorMessage404;
        }

        if (e.response.data && e.response.data.message){
            return e.response.data.message
        }
        else if (e.response.data && e.response.data.errors){
            return parseValidationError(e.response.data.errors);
        }
        else{
            return defaultMessage
        }
    }

    return defaultMessage;
}